<template>
	<div class="box">
		<div class="title">
			<h3>{{ title1 }}</h3>
			<img src="@/assets/img/feature.png" alt="" />
		</div>
		<div class="cont">
			<!-- <h3>{{ title2 }}</h3>
			<p>
				一、湖南、湖北、江西至洋山、外高桥航线：班期每周二、五
			</p>
			<p>
				二、安徽、江苏至洋山、外高桥航线：班期每周一、二、四、五
			</p> -->
			<img style="width: 907px;display: block;margin: auto;" src="../../assets/img/zhongyi/hangxian.jpg" alt="">
			<div style="width: 907px;margin: auto;">
				<span style="color: #2b7eef;">
					航线覆盖主要口岸：
				</span>
				<span>
					武汉、黄石、九江、合肥、芜湖、马鞍山、南京、镇江、扬州、泰州、常州、江阴、张家港、南通、常熟、太仓等
				</span>
			</div>
			<!-- <el-table :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{
          background: '#3482E7',
          color: '#FFFFFF',
          border: '#eee',
		  fontSize:'18px'
        }" align="center" header-align="center">
				<el-table-column align="center" header-align="center" prop="portname" label="外港" width="200">
					<template slot-scope="scope">
						<span style="font-size: 18px;">{{scope.row.portname}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="name" label="中文船名">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="load" label="载重量 （顿）" width="200">
					<template slot-scope="scope">
						<span style="font-size: 18px;">{{scope.row.load}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="positions" label=" 仓量 （TEU）" width="200">
					<template slot-scope="scope">
						<span style="font-size: 18px;">{{scope.row.positions}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="type" label="危险品类别">
					<template slot-scope="scope">
						<span style="font-size: 18px;">{{scope.row.type}}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="bakone" label="建成日期">
				</el-table-column>
			</el-table> -->
			<h4>
				<span style="color: red;">注：</span>在线运营船舶的自有船比例达90%以上，其中，“中艺泽泰”轮是长江下游支线船舶中舱位最大的船舶，舱位888TEU
			</h4>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title1: "海运驳船服务",
				title2: "航线和航期",
				tableData: [{
						outName: "洋山",
						chinaName: "德林",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "2020",
					},
					{
						outName: "洋山",
						chinaName: "中艺润通",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "洋山",
						chinaName: "中艺润达",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "洋山",
						chinaName: "中艺泽泰",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "德林",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "中艺润通",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "中艺润达",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "中艺泽泰",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "德林",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "中艺润通",
						weight: "234",
						storage: "3.2",
						type: 10,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "中艺润达",
						weight: "234",
						storage: "3.2",
						type: 22,
						date: "",
					},
					{
						outName: "外高桥",
						chinaName: "111",
						weight: "222",
						storage: "3.2",
						type: 10,
						date: "",
					},
				],
			};
		},
		computed: {
			tableDataTitle() {
				if (this.tableData && Array.isArray(this.tableData)) {
					let str = this.tableData[0].outName;
					let first = 0;
					let two = 0;
					this.tableData.forEach((item) => {
						if (item.outName == str) {
							first++;
						} else {
							two++;
						}
					});
					return [first, two];
				}
			},
		},
		methods: {
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				let arr = this.tableDataTitle;
				let first = row;
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						// 合并第一行到第四行，从第一行开始，共4行
						return {
							rowspan: arr[0],
							colspan: 1,
						};
					} else if (rowIndex === arr[0]) {
						// 合并第五行到第九行，从第五行开始，共5行
						return {
							rowspan: arr[1],
							colspan: 1,
						};
					} else {
						// 其余被合并的行，诸如1、2、3、5、6、7、8、10、11、12、13全都设为0
						return {
							rowspan: 0,
							colspan: 0,
						};
					}
				}
			},
			getFeatureList() {
				this.$http.get("/webpc/pcservicefeatures/list").then((res) => {
					this.tableData = res.data.detail;
					console.log(res);
				});
			}
		},
		created() {
			this.getFeatureList();
		},
	};
</script>
<style lang="scss" scoped>
	.box {
		width: 100%;
		height: 100%;
		overflow: hidden;

		.title {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-color: #efefef;

			h3 {
				color: #3482e7;
				font-size: 22px;
				font-weight: 600;
				margin-top: 30px;
			}

			img {
				width: 46%;
				height: auto;
				margin-top: 20px;
				margin-left: 130px;
				margin-bottom: 40px;
			}
		}

		.cont {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			color: #444444;

			h3 {
				color: #3482e7;
				font-size: 22px;
				font-weight: 600;
				margin: 20px auto;
				text-align: center;
			}

			p {
				font-size: 14px;
				height: 40px;
				line-height: 40px;
			}

			div {
				margin-top: 10px;
				font-size: 14px;
				display: flex;
				flex-direction: column;
			}

			h4 {
				// color: #2b7eef;
				font-size: 14px;
				width: 907px;
				margin: 20px auto 40px ;
			}
		}
	}
</style>
